import React from 'react';
import { Helmet } from 'react-helmet';
import AboutHero from '../components/about/AboutHero';
import PhilosophieSection from '../components/about/PhilosophieSection';
import MissionSection from '../components/about/MissionSection';
import ExpertiseSection from '../components/about/ExpertiseSection';
import TeamSection from '../components/about/TeamSection';
import GeschichteSection from '../components/about/GeschichteSection';
import KarriereSection from '../components/about/KarriereSection';

const AboutUsPage = () => {
  return (
    <>
      <Helmet>
        <title>Über uns | YADE Home GmbH</title>
        <meta name="description" content="Lernen Sie YADE Home GmbH kennen - Projektentwickler und Immobilienmakler aus Köln. Erfahren Sie mehr über unsere Philosophie, unser Team und unsere Mission." />
      </Helmet>
      
      <main>
        <AboutHero />
        <PhilosophieSection />
        <MissionSection />
        <ExpertiseSection />
        <TeamSection />
        <GeschichteSection />
        <KarriereSection />
      </main>
    </>
  );
};

export default AboutUsPage;
